// 出典canon: docs/research-overseas-butler-schools-20260725.md

export type OverseasSchool = {
  slug: string;
  name: string;
  nameJa: string;
  country: string;
  city: string;
  region: string;
  official: string;
  founded: string;
  courses: string[];
  address: string;
  awards: string[];
  note: string;
  fetched: string;
};

export const overseasSchools: OverseasSchool[] = [
  {
    slug: 'tiba-netherlands',
    name: 'The International Butler Academy (TIBA)',
    nameJa: 'インターナショナル・バトラー・アカデミー（TIBA）',
    country: 'オランダ',
    city: 'Simpelveld',
    region: 'ヨーロッパ',
    official: 'https://www.butlerschool.com/',
    founded: '公式サイトに設立年の記載なし（25周年に言及あり）',
    courses: [
      '8週間 Private Butler Training',
      '4週間 Luxury Hotel & Resort Training',
    ],
    address: 'Pater Damiaanstraat 38, 6369 SV Simpelveld, The Netherlands',
    awards: [
      'Capital Finance International「The Best Butler School in the World」(2019-2020)',
      'Corporate Livewire Global Award「Specialist Education & Training Provider of the Year」(2021-2025)',
    ],
    note: 'TEL +31-(0)344-673939。カリキュラム800時間・施設80,000 sq ft・135室は検索結果ベースで公式該当ページの要再確認。学費は公式トップに記載なし（検索結果の記述は公式未確認のため掲載保留）。',
    fetched: '2026-07-25',
  },
  {
    slug: 'tiba-china',
    name: 'The International Butler Academy China',
    nameJa: 'インターナショナル・バトラー・アカデミー中国',
    country: '中国',
    city: '成都',
    region: 'アジア',
    official: 'https://www.butlerschool.com/the-extras/tiba-china/',
    founded: '2014年7月10日開校',
    courses: [
      '6週間のバトラー・ホスピタリティ課程（英語と中国語のバイリンガル、中国国籍者向け）',
    ],
    address: '四川省 成都（Chengdu）。私邸ヴィラを校舎とし、研修室・寝室・バー・西洋式/中華式キッチン・プール・サウナを備える',
    awards: [],
    note: '中国初の常設・認定バトラースクールと自ら称しています（自己申告）。旧独自ドメイン butler-academy-china.com はDNS解決不可（ENOTFOUND）で現在アクセス不能。',
    fetched: '2026-07-25',
  },
  {
    slug: 'saba-south-africa',
    name: 'SABA International Butler Academy & Training School',
    nameJa: 'SABAインターナショナル・バトラー・アカデミー',
    country: '南アフリカ',
    city: 'ケープタウン',
    region: 'アフリカ・中東',
    official: 'https://www.thebutlerschool.com/',
    founded: '公式サイトに設立年の記載なし',
    courses: [
      'Residential Butler Training（4週間）',
      'Hotel Butler Training（5日間のオープンコース）',
      'Luxury Mindset',
      'Hospitality Training',
      '客先オンサイト研修',
    ],
    address: '南アフリカ・ケープタウン',
    awards: [],
    note: 'info@butleracademy.co.za / +27 (0)61 631 2878。開催地はモルディブ、ケープタウン（2027年1月予定）ほか世界各地。一部プログラムでSABA certificationを発行。中国向け「China Butler Training 中国区管家培训」ページあり。創設者は公式に記載なし。',
    fetched: '2026-07-25',
  },
  {
    slug: 'british-butler-academy',
    name: 'British Butler Academy',
    nameJa: 'ブリティッシュ・バトラー・アカデミー',
    country: '英国',
    city: 'London',
    region: 'ヨーロッパ',
    official: 'https://www.bespokebureau.com/butler-academy/butler-school/',
    founded: '公式サイトに設立年の記載なし',
    courses: [
      'Butler',
      'Hotel Butler',
      'House Manager',
      'Interior Yacht Crew',
      'Housekeeper',
      'Hotel Staff',
      'Silver Service',
    ],
    address: '7 Bell Yard, Strand, London WC2A 2JR, United Kingdom',
    awards: [],
    note: '運営はBespoke Bureau。期間は1日〜2週間（内容によりカスタム）。定員は1コース最大12名。個人向け・企業内研修・オーダーメイド。講師が世界各地へ出張。料金・認定は公式に明示なし。',
    fetched: '2026-07-25',
  },
  {
    slug: 'magnums-academy',
    name: 'Magnums Academy（Magnums Butlers）',
    nameJa: 'マグナムズ・アカデミー',
    country: 'オーストラリア',
    city: 'クイーンズランド州',
    region: 'オセアニア',
    official: 'https://www.magnumsacademy.com/',
    founded: '1987年から専門バトラー等の訓練実績あり（公式トップに設立年の明記なし）',
    courses: [
      '7 Star Service™',
      'PULSE',
      'Quality Ambassador™',
      'Leadership & Cultural Intelligence',
      'IAMI GUEST',
      'Bespoke Consulting',
    ],
    address: 'クイーンズランド州（研修は世界各地）',
    awards: [],
    note: 'PrincipalはJosephine Ive（「UK\'s First Female Butler」と紹介）。認定: IAMI GUEST認定、7 Star Service™ラペルピン、The Magnums Method™（商標）。課程期間は公式トップに記載なし。',
    fetched: '2026-07-25',
  },
  {
    slug: 'charles-macpherson-academy',
    name: 'The Charles MacPherson Academy',
    nameJa: 'チャールズ・マクファーソン・アカデミー',
    country: 'カナダ',
    city: 'トロント',
    region: '北米',
    official: 'https://www.charlesmacpherson.com/about-the-academy/',
    founded: '2009年',
    courses: [
      'The Charles MacPherson Academy Online（オンライン課程）',
      'Hotel Butler 201（対面課程）',
    ],
    address: '260 Adelaide Street East P.O. Box 82, Toronto, Ontario M5A 1N1, Canada',
    awards: [],
    note: '創設者Charles MacPherson。バトラー及びハウスホールドマネージャー向けのprivate career college。人材の採用・紹介、私的サービス職の教育訓練、HNW/UHNW家庭へのコンサルティングも行う。',
    fetched: '2026-07-25',
  },
  {
    slug: 'butler-training-institute',
    name: 'The International Butler Training Institute B.V.',
    nameJa: 'インターナショナル・バトラー・トレーニング・インスティテュート',
    country: 'オランダ',
    city: 'Lochem',
    region: 'ヨーロッパ',
    official: 'https://butlertraininginstitute.com/',
    founded: '公式サイトに設立年の記載なし',
    courses: [
      '12日間のバトラー訓練',
      '3週間のバトラー訓練',
      '2ヶ月のバトラー訓練',
      'プライベートバトラー訓練',
      'ホテル訓練',
      'ワークショップ',
    ],
    address: 'Marinus Naefflaan 11, 7241 GC Lochem, Netherlands',
    awards: [],
    note: '創設者: Cornelis Greveling。TEL +31 85 0603604。商業会議所番号 80517463。標語は"Distinctly different" / "Learning By Doing"。開催地はオランダ・Lochem（本拠）。中国向け・ドバイのホテル向け研修ページあり。料金・認定は公式に記載なし。private butler / steward / valet / hotel butler / house manager / estate manager を目指す人向け。',
    fetched: '2026-07-25',
  },
  {
    slug: 'butler-academy-paris',
    name: 'Butler Academy',
    nameJa: 'バトラー・アカデミー（パリ）',
    country: 'フランス',
    city: 'パリ',
    region: 'ヨーロッパ',
    official: 'https://butler-academy.com/en/',
    founded: '公式サイトに設立年の記載なし',
    courses: [],
    address: '28 rue de Chambery 75015 Paris',
    awards: [],
    note: 'モンパルナスとエッフェル塔の間に所在。WSET®認定センター。Qualiopi認証。定員最大15名。英語・フランス語・イタリア語・ポルトガル語・中国語の5言語で研修/認定。課程期間・料金は未取得。',
    fetched: '2026-07-25',
  },
  {
    slug: 'the-english-manner',
    name: 'The English Manner',
    nameJa: 'ザ・イングリッシュ・マナー',
    country: '英国',
    city: '公式サイトに都市の記載なし',
    region: 'ヨーロッパ',
    official: 'https://theenglishmanner.com/',
    founded: '2026年時点で創立25年',
    courses: [
      'エチケット・プロトコル教育',
    ],
    address: '公式サイトに住所の詳細記載なし',
    awards: [],
    note: 'バトラー専業校ではない。代表はWilliam Hanson。王室・外交筋の家庭、企業、学校・大学、個人へ世界各地で研修。Forbes Business Councilメンバー、Provider of Training Excellence認定、Institute of Leadership承認研修、Leading Protocol & Etiquette Schools of the World会員。',
    fetched: '2026-07-25',
  },
  {
    slug: 'modern-butlers-institute',
    name: 'The International Institute of Modern Butlers',
    nameJa: 'インターナショナル・インスティテュート・オブ・モダン・バトラーズ',
    country: '米国',
    city: '公式サイトに都市の記載なし',
    region: '北米',
    official: 'https://www.modernbutlers.com/',
    founded: '設立から二十年以上（公式トップに設立年の明記なし）',
    courses: [
      '個人邸およびホテル・リゾートでの研修（世界各地）',
      'コンサルティング',
    ],
    address: '公式サイトに所在地の詳細記載なし',
    awards: [],
    note: '米国拠点の国際団体。業界標準の設定・引き上げを目的に業界関係者の要請で設立された機関。記事・書籍の出版も行う。',
    fetched: '2026-07-25',
  },
  {
    slug: 'british-butler-institute',
    name: 'British Butler Institute',
    nameJa: 'ブリティッシュ・バトラー・インスティテュート',
    country: '英国',
    city: '公式サイトに都市の記載なし',
    region: 'ヨーロッパ',
    official: 'https://www.britishbutlerinstitute.com/',
    founded: '公式本文が取得できず設立年は未確認',
    courses: [],
    address: '公式サイトに住所の詳細記載なし',
    awards: [],
    note: 'ラグジュアリー住宅・ホスピタリティ市場向けの国際的訓練プロバイダ。Finishing School部門あり。公式トップの本文取得がtruncatedのため、設立年・創設者・課程期間・認定などの詳細は未取得（公式サイトに記載を確認できず）。コースページ: https://www.britishbutlerinstitute.com/butler-school/',
    fetched: '2026-07-25',
  },
  {
    slug: 'dubai-butler-schools',
    name: 'Dubai / UAE Butler Schools',
    nameJa: 'ドバイ／UAEのバトラー学校群',
    country: 'UAE',
    city: 'ドバイ',
    region: 'アフリカ・中東',
    official: 'https://www.dubaibutleracademy.com/',
    founded: '各校とも公式サイトに設立年の記載なし（未確認）',
    courses: [
      'おおむね3〜6日間のショートコースが中心（各校公式で要個別確認）',
    ],
    address: 'ドバイ（QE2 Hospitality Academy FZE: Port Rashid CT-1 QE2 Ship, Dubai, UAE ほか）',
    awards: [],
    note: '複数校が集積。(1) QE2 Hospitality Academy FZE（Port Rashid CT-1 QE2 Ship, Dubai, UAE / TEL +971 4 888 1560）。ドバイ初かつ唯一の職業訓練型バトラー・ホスピタリティ学校と自ら称しています（自己申告）。CTH（Confederation of Tourism & Hospitality）承認教育センター。(2) The British Butler Institute Dubai: 客船QE2のデッキ1に開設、船内で完結する没入型研修。(3) SABA International Butler Academy（ドバイ拠点）: https://www.thebutlerschool.com/dubai-butler-training/ ／ 南アフリカ・モルディブ・中国と合わせ世界3拠点＋ドバイ運営。5つ星ホテル・王宮・クラブ・リゾート向け。(4) Dubai Butler Academy: https://www.dubaibutleracademy.com/ ／ 個人・ホテル・リゾート・宮殿・ヨット・プライベートジェット向け訓練。',
    fetched: '2026-07-25',
  },
];

export const overseasRegions = ['ヨーロッパ', '北米', 'アジア', 'アフリカ・中東', 'オセアニア'] as const;
